<div class="camera-capture">
    <!-- Header -->
    <!-- <div class="camera-header">
    <h4 class="camera-label">{{ label }}</h4>
    <button mat-icon-button (click)="cancel()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div> -->

    <!-- Error Message -->
    <div *ngIf="error" class="error-message">
        <mat-icon>error</mat-icon>
        <span>{{ error }}</span>
    </div>

    <!-- Camera View -->
    <div class="camera-container">
        <!-- Video Preview -->
        <video #video autoplay playsinline class="camera-video" [class.mirror]="currentFacingMode === 'user'"></video>

        <canvas #overlay></canvas>

        <!-- Placeholder when initializing -->
        <div *ngIf="isInitializing && !isCameraActive" class="camera-placeholder">
            <mat-spinner diameter="50" color="accent"></mat-spinner>
            <p>{{ 'initializingCamera' | translate }}</p>
        </div>

        <!-- Loading overlay -->
        <div *ngIf="isCapturing" class="capturing-overlay">
            <mat-spinner diameter="50"></mat-spinner>
            <p>{{ 'capturing' | translate }}</p>
        </div>
    </div>

    <!-- Camera Controls -->
    <div class="camera-controls">
        <!-- Switch Camera (only if multiple cameras) -->
        <button *ngIf="isCameraActive && hasMultipleCameras" mat-icon-button (click)="switchCamera()" matTooltip="Switch Camera"
            class="control-btn switch-camera-btn">
            <mat-icon>{{ getCameraIcon() }}</mat-icon>
        </button>

        <!-- Action Buttons when camera is active -->
        <div class="action-btns" *ngIf="isCameraActive">
            <!-- Capture Photo Button -->
            <button mat-button (click)="capturePhoto()" [disabled]="isCapturing" class="capture-btn">
                <mat-icon>camera</mat-icon>
                {{ 'takePhoto' | translate }}
            </button>

            <!-- Cancel Button -->
            <button mat-button (click)="cancel()" class="cancel-btn">
                <mat-icon>close</mat-icon>
                {{ "Cancel" | translate }}
            </button>
        </div>

        <!-- Retry and Cancel buttons when there's an error -->
        <div class="action-btns" *ngIf="error && !isCameraActive && !isInitializing">
            <button mat-button (click)="startCamera()" class="capture-btn">
                <mat-icon>refresh</mat-icon>
                {{ 'retry' | translate }}
            </button>

            <button mat-button (click)="cancel()" class="cancel-btn">
                <mat-icon>close</mat-icon>
                {{ "Cancel" | translate }}
            </button>
        </div>
    </div>

    <!-- Instructions -->
    <!-- <div class="camera-instructions" *ngIf="isCameraActive">
    <mat-icon>info</mat-icon>
    <p>Position the document within the frame and ensure it's well-lit and in focus</p>
  </div> -->
</div>